export default function Footer() {
  const quickLinks = [
    { label: '新番热度榜', href: '#ranking' },
    { label: '追更专题', href: '#index' },
    { label: '焦点推荐', href: '#carousel' },
    { label: '追更视频', href: '#media' },
    { label: '常见问答', href: '#faq' },
    { label: '联系我们', href: '#contact' },
  ];

  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <a href="#hero" className="flex items-center gap-2 mb-4 whitespace-nowrap cursor-pointer">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-line text-background-50 text-lg"></i>
              </span>
              <span className="text-xl font-heading text-foreground-900 font-semibold">
                樱花动漫
              </span>
            </a>
            <p className="text-sm text-foreground-600 leading-relaxed">
              樱花动漫之家专注动漫追更，提供连载动漫更新、最新动漫新番在线观看，免费追更动漫大全，热门新番推荐。追更动漫，从这里开始。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              快速导航
            </h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              追更指南
            </h4>
            <ul className="space-y-2.5">
              <li><span className="text-sm text-foreground-600 whitespace-nowrap">新番更新时间表</span></li>
              <li><span className="text-sm text-foreground-600 whitespace-nowrap">追更提醒设置</span></li>
              <li><span className="text-sm text-foreground-600 whitespace-nowrap">番剧分类浏览</span></li>
              <li><span className="text-sm text-foreground-600 whitespace-nowrap">社区讨论指南</span></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              合作伙伴
            </h4>
            <p className="text-sm text-foreground-500 leading-relaxed">
              更多合作伙伴即将入驻，敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 樱花动漫之家. 本站内容仅供学习交流，版权归原作者所有。
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-foreground-500 whitespace-nowrap">追更动漫，从这里开始</span>
          </div>
        </div>
      </div>
    </footer>
  );
}